import React, { useEffect, useState, useCallback } from 'react';
import Button from '@mui/material/Button';
import { Container, Row, Col } from 'reactstrap';
import TextField from '@mui/material/TextField';
import { useForm, Controller } from "react-hook-form";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import PasswordStrengthMeter from '../Common/PasswordStrengthMeter/PasswordStrengthMeter';
import { apiCommonTrigger } from '../../../Utils/apiServicehelper';
import { Config } from '../../../Utils/Config';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ResetPassword = (props) => {
    const { handleSubmit, control, watch, register } = useForm();
    const navigate = useNavigate();

    const [userDetails, setUserDetails] = React.useState({
        confirmPassword:'',
        password:''
    });
    const [pwdErr, setPwdErr] = React.useState('');
    const [confirmPwdErr, setConfirmPwdErr] = React.useState('');
    const [validToken, setValidToken] = React.useState(false);
    const [passwordUpdate, setPasswordUpdate] = React.useState(false);
    const [secureIdExpired, setSecureIdExpired] = React.useState(false);
    const [secureId, setSecureId] = React.useState('');
    const [isLoading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [snackClr, setSnackClr] = React.useState('');
    const [snackMsg, setSnackMsg] = React.useState('');

    // Validate secure id
    useEffect(() => {
        verifyToken();
    }, []);

    const getParameterValues = (key) =>{
        var pageURL = window.location.search.substring(1);
        var urlQS = pageURL.split('&');
        for (var i = 0; i < urlQS.length; i++) {
            urlQS[i] = urlQS[i].replace(/==/g, '~~')
            var paramName = urlQS[i].split('=');				
            if (paramName[0] == key) {
                //replace the special char like "+","&" etc from value
                var value = paramName[1].replace(/%20/g, ' ').replace(/%26/g, '&');
                // var value = paramName[1].replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
                value = value.replace(/~~/g, '==');
                if(paramName.length>2){
                value = value + '=';
                }
                return value;
            }
        }
    }

    // Activation key verification API
    const verifyToken = () =>{
        setLoading(true);
		var secId = getParameterValues('secureid');
        setSecureId(secId);
          apiCommonTrigger("post",`${Config.API_URL}/account/ResetLink`, {
            "SecureToken": secId
          }) 
            .then((res) => {
                if (res.status === 200) {
                    if(res.data === "success"){
                        setLoading(false);
                        setValidToken(true);
                    }
                }
             
                else{
                    if (res.status === 400){
                        setLoading(false);
                        setSecureIdExpired(true);
                    }
                    setLoading(false);
                    handlingCatchError(res, navigate);
                  }
                  
            })
            .catch(err => {
                setLoading(false);
                handlingCatchError(err, navigate);
              })
    }

    const onChangeValidation = (e) => {
        // Password validation
        if (e.target.name === 'password') {
            // var regName = /^(.{0,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{4,})|(.{1,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{3,})|(.{2,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{2,})|(.{3,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{1,})|(.{4,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{0,})$/;
            // var name = e.target.value;
            // if (name.length === 0) {
            //     setPwdErr('Password required');
            // } else {
            //     if (!regName.test(name)) {
            //         setPwdErr('Passwords are case-sensitive.');
            //     } else {
            //         if (name.length <= 5) {
            //             setPwdErr('Your Password must be 6 characters');
            //         } else if (name.length >= 26) {
            //             setPwdErr('Your Password maximum limit is 25 characters');
            //         } else {
            //             if (userDetails.confirmPassword && userDetails.confirmPassword !== name) {
            //                 setConfirmPwdErr('Password does not match.');
            //                 setPwdErr('');
            //             } else {
            //                 setPwdErr('');
            //                 setConfirmPwdErr('');
            //             }
            //         }
            //     }
            // }

            let password  = e.target.value;
            setUserDetails({
                ...userDetails,
                password:e.target.value
              });
              setPwdErr('');
            let capsCount, smallCount, numberCount, symbolCount
            if (password.length < 4) {
                setPwdErr("Password must be minimum 4 characters include one UPPERCASE, lowercase, number and special character: @$! % * ? &");
                return;
            }
            else {
            capsCount = (password.match(/[A-Z]/g) || []).length
            smallCount = (password.match(/[a-z]/g) || []).length
            numberCount = (password.match(/[0-9]/g) || []).length
            symbolCount = (password.match(/\W/g) || []).length
            if (capsCount < 1) {
                setPwdErr("Must contain one UPPERCASE letter");
                return;
            }
            else if (smallCount < 1) {
                setPwdErr("Must contain one lowercase letter");
                return;
            }
            else if (numberCount < 1) {
                setPwdErr("Must contain one number");
                return;
            }
            else if (symbolCount < 1) {
                setPwdErr("Must contain one special character: @$! % * ? &");
                return;
            }

            if (userDetails.confirmPassword && userDetails.confirmPassword !== password) {
                setConfirmPwdErr('Password does not match.');
                setPwdErr('');
                return;
            }else{
                setPwdErr('');
                setConfirmPwdErr('');
                return;
            }            
        }
    }


        // Confirm password validation
        if (e.target.name === 'confirmPassword') {
            var name = e.target.value;
            if (name.length === 0) {
                setConfirmPwdErr('Confirm password required');
            } else {
                if (name === userDetails.password) {
                    setConfirmPwdErr('');
                } else {
                    setConfirmPwdErr('Password does not match');
                }
            }
        }
        setUserDetails({ ...userDetails, [e.target.name]: e.target.value });
    }

    // Form submission
    const onHandleSubmit = (e) => {
        e.preventDefault();
        if (!pwdErr && !confirmPwdErr && userDetails.password && userDetails.confirmPassword && secureId) {
            setLoading(true);
             apiCommonTrigger("post",`${Config.API_URL}/account/updateuserpassword`, {
             "SecureToken":secureId,
                    "Password":userDetails.password,
                    "ConfirmPassword":userDetails.confirmPassword
          }) .then((res) => {
                    if (res.status === 200) {
                        if(res.data === "success"){
                            setLoading(false);
                            setPasswordUpdate(true);
                        }
                    }
                    else{
                        setLoading(false);
                        handlingCatchError(res, navigate);
                      }
                })
                .catch(err => {
                    setLoading(false);
                    handlingCatchError(err, navigate);
                  })
        }else{
            if(!pwdErr && !userDetails.password){
                setPwdErr('Please fill out this field');
            }
            if(!confirmPwdErr && !userDetails.confirmPassword){
                setConfirmPwdErr('Please fill out this field');
            }
        }
    }

    //   Reset form
    const resetForm = () => {
        setUserDetails({});
        setPwdErr('');
        setConfirmPwdErr('');
    }

    const handleClick = () => {
        setOpen(true);
    };
    
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const [isStrength, setStrength] = React.useState(null);
    const dataHandler = async (childData) => {
        setStrength(childData);
    }

    return (
        <div className='signin-page common-page'>
            {isLoading ? (
                <div className="loader-wrap">
                <div className="default-page loading loading-center"></div>
                </div>
            ) : (
                ""
            )}
            <Container>
                {validToken ?
                <div className='signin-form'>
                    <Row className='d-flex justify-content-center'>
                        <Col md={5} className="user-signin">
                            <form onSubmit={(e) => onHandleSubmit(e)} id='RVParkIQ_reset_pwd_form'>
                                <h2>Reset Password</h2>
                                <Row>
                                    <Col xs={12}>
                                        <TextField
                                            label="New Password"
                                            id="outlined-password-input"
                                            fullWidth
                                            value={userDetails.password ? userDetails.password : ''}
                                            name="password"
                                            onChange={(e) => onChangeValidation(e)}
                                            error={!!pwdErr}
                                            helperText={pwdErr ? pwdErr : null}
                                            type="password"
                                            margin="normal"
                                            required
                                            className='textbox-custom'
                                        />
                                        <PasswordStrengthMeter password={userDetails.password} actions={dataHandler}/>
                                    </Col>
                                    <Col xs={12}>
                                        <TextField
                                            label="Confirm Password"
                                            id="outlined-password-input"
                                            fullWidth
                                            value={userDetails.confirmPassword ? userDetails.confirmPassword : ''}
                                            name="confirmPassword"
                                            onChange={(e) => onChangeValidation(e)}
                                            error={!!confirmPwdErr}
                                            helperText={confirmPwdErr ? confirmPwdErr : null}
                                            type="password"
                                            margin="normal"
                                            required
                                            className='textbox-custom pwd-field'
                                        />
                                    </Col>
                                </Row>
                                <Row className='d-flex justify-content-center mt-4'>
                                    <Button onClick={() => resetForm()} className="reset-opt">Reset</Button>
                                    <Button onClick={(e) => onHandleSubmit(e)} type="submit" className='market-btn'>Submit</Button>
                                </Row>
                            </form>
                        </Col>
                    </Row>
                </div>: <p className='text-center please-wait-txt'>Please wait while we process your request...</p>}
            </Container>
            <Dialog open={passwordUpdate === true || secureIdExpired === true} className="modal-custom-popup forgot-pwd">
                <DialogTitle>{passwordUpdate ? 'Your password has been updated successfully!' : secureIdExpired ? 'Your token has been expired!' : null}</DialogTitle>
                <DialogContent><p>{passwordUpdate ? "Now you can login with your new password. If you need further assistance please contact support." : secureIdExpired ? 'You can create a new reset link from signin page by clicking forgot password. If you need further assistance please contact support.' : null}</p></DialogContent>
                <DialogActions>
                    <Link to={'/signin'} className="market-btn">OK</Link>
                </DialogActions>
            </Dialog>
            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={handleClose} severity={snackClr} sx={{ width: '100%' }}>
                    {snackMsg}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default ResetPassword;